var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("k-icon-button", {
          staticClass: "btn-close",
          attrs: { type: "left1" },
          nativeOn: {
            click: function($event) {
              return _vm.close()
            }
          }
        }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm.opened
          ? _c("NotificationsList", {
              on: {
                close: function($event) {
                  return _vm.close()
                }
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("h4", [_vm._v("Notificações")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18b20496", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18b20496","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Layout/NotificationsSidebar.vue
// module id = 2138
// module chunks = 1610